import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-391c094a")

_pushScopeId("data-v-391c094a")
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "notRequired" }
const _hoisted_3 = { class: "p-field p-grid" }
const _hoisted_4 = { class: "p-col-6 p-p-2" }
const _hoisted_5 = { class: "p-col-6 p-p-2" }
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = { class: "p-col-6" }
const _hoisted_8 = { class: "p-col-6" }
const _hoisted_9 = { class: "p-field p-grid" }
const _hoisted_10 = { class: "p-col-11" }
const _hoisted_11 = { class: "p-field p-grid" }
const _hoisted_12 = { class: "p-col-12" }
const _hoisted_13 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_16 = { class: "p-col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image, key) => {
        return (_openBlock(), _createBlock("div", { key: key }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_Button, {
                  class: ["tooltipButton formBox", { notRequired: true }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_info_button),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('help.imageDescriptionTitle')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [
                    _directive_tooltip,
                    _ctx.$t('help.imageDescription'),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: image.imageText,
                  "onUpdate:modelValue": ($event: any) => (image.imageText = $event),
                  class: ["p-inputtext-sm p-mb-2", { 'is-error': _ctx.error }]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode(_component_Button, {
                  class: ["tooltipButton formBox", { notRequired: true }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_info_button),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('help.imageCommentTitle')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [
                    _directive_tooltip,
                    _ctx.$t('help.imageComment'),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: image.userComment,
                  "onUpdate:modelValue": ($event: any) => (image.userComment = $event),
                  class: ["p-inputtext-sm p-mb-2", { 'is-error': _ctx.error }]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (image.imageBlob.length > 1)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      id: "upload-image",
                      src: image.imageBlob,
                      title: image.fileName,
                      class: "image"
                    }, null, 8, ["src", "title"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_FileUpload, {
                  maxFileSize: 10000000,
                  accept: "image/png, image/jpg, image/jpeg, image/bmp",
                  class: [{ 'is-error': _ctx.error }, "p-p-2"],
                  mode: "basic",
                  customUpload: true,
                  onSelect: ($event: any) => (_ctx.select($event, key)),
                  onUploader: ($event: any) => (_ctx.select($event, key)),
                  invalidFileSizeMessage: _ctx.$t('form.exceedFileSize'),
                  chooseLabel: _ctx.$t('upload'),
                  auto: true,
                  disabled: image.imageBlob.length > 1
                }, null, 8, ["class", "onSelect", "onUploader", "invalidFileSizeMessage", "chooseLabel", "disabled"])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        (_ctx.images.length >= 1)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                iconPos: "left",
                label: _ctx.$t('delete'),
                class: "appButton p-button-raised p-button-danger p-button-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remove(_ctx.key)))
              }, null, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_Button, {
            disabled: _ctx.images.length >= 3,
            icon: "pi pi-camera",
            iconPos: "left",
            label: _ctx.$t('form.add_image'),
            class: "appButton p-button-raised p-button-success p-button-sm p-field p-mb-2 p-mr-2",
            onClick: _ctx.add
          }, null, 8, ["disabled", "label", "onClick"])
        ])
      ])
    ])
  ], 64))
})